import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RegularFairDayItem } from '@csm/shared';
import { EventsService } from '../../services';
import { ActionButtonClick } from '../event-view/action-buttons/action-buttons.component';
import { EventOverviewData } from '../event-view/event-view.resolvers';
import { ModalService } from '../event-view/modal/modal.service';

@Component({
    selector: 'cf-event-overview',
    templateUrl: './event-overview.component.html'
})
export class EventOverviewComponent {
    public readonly resolvedData = this.route.snapshot.data.resolvedData as EventOverviewData;
    public readonly event = this.resolvedData.event;
    public readonly isVirtualFair = this.resolvedData.isVirtualFair;
    public readonly employers = this.resolvedData.employers;
    public readonly regularFairDays = this.resolvedData.regularFairDays;
    public readonly actionButtons = this.resolvedData.actionButtons;

    constructor(
        private route: ActivatedRoute,
        private eventsService: EventsService,
        private modalService: ModalService
    ) {}

    public onButtonClick(data: ActionButtonClick): void {
        if (data.button.id === 'registerAsEmployer') {
            this.eventsService.registerAsAnEmployer(this.event.event_id, this.event.disable_autofill);
        }
    }

    public onOpenParkingInfoModal(day: RegularFairDayItem): void {
        this.modalService.openModal({
            titleLabel: 'event overview.Parking Information',
            content: day.parkingInformation
        });
    }
}
